
export default {
  props: { serviceData: { type: Object, default: () => {} } },
};
